module.exports = __webpack_public_path__ + "static/media/dashboardLight.f4cfb47f.svg";